import React from 'react';
import PropTypes from 'prop-types';
import { WIZARD_STEP } from 'constants/wizardConstants';
import SelectHome from 'components/WizardContents/Home/SelectHome';
import InputGnbMenu from 'components/WizardContents/GnbMenu/InputGnbMenu';
import InputGnbMenuGroup from 'components/WizardContents/GnbMenu/InputGnbMenuGroup';
import InputBoard from 'components/WizardContents/Board/InputBoard';
import InputAnniversary from 'components/WizardContents/Anniversary/InputAnniversary';
import InputDepartment from 'components/WizardContents/Department/InputDepartment';
import InputJobTitle from 'components/WizardContents/JobTitle/InputJobTitle';

export const BodyContents = ({ step }) => {
  let contents = '';

  switch (step) {
    case WIZARD_STEP.SETUP_JOBTITLE:
      contents = <InputJobTitle />;
      break;
    case WIZARD_STEP.SETUP_DEPARTMENT:
      contents = <InputDepartment />;
      break;
    case WIZARD_STEP.SETUP_HOME:
      contents = <SelectHome />;
      break;
    case WIZARD_STEP.SETUP_GNB_MENU:
      contents = (
        <>
          <InputGnbMenu />
          <InputGnbMenuGroup />
        </>
      );
      break;
    case WIZARD_STEP.SETUP_BOARD:
      contents = <InputBoard />;
      break;
    case WIZARD_STEP.SETUP_ANNIVERSARY:
      contents = <InputAnniversary />;
      break;
    default:
      break;
  }
  return <>{contents}</>;
};
BodyContents.propTypes = {
  step: PropTypes.number.isRequired,
};
BodyContents.defaultProps = {};
export default BodyContents;
